import { createSelector } from 'reselect'

import getActivitySelector from './interactive_video_participant_activity_selector'
import { userCredentialsSelector } from 'redux/selectors/user'

const interactiveVideoData = state => state.interactiveVideo

export default createSelector(
	[ interactiveVideoData, getActivitySelector, userCredentialsSelector],
	(interactiveVideo, activity, userCredentials) => ({
		jwt: userCredentials.interactiveVideo,
		mediaSessionUid: interactiveVideo.uid,
		questionUid: activity.currentActivity.payload.uid,
	})
)
